module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/offertecentralihome/offertecentralihome.component.scss
// module id = ./src/app/offertecentralihome/offertecentralihome.component.scss
// module chunks = main